import { MILLISECONDS_DAY } from 'components/timer-widget/utils'

export default {
  state: () => ({
    timestampClosed: localStorage.getItem('promotedBonusTimestampClosed'),
    promotedBonusList: [],
  }),
  mutations: {
    UPDATE_PROMOTED_BONUS_LIST(state, payload) {
      state.promotedBonusList = payload
    },
    UPDATE_TIMESTAMP_CLOSED(state) {
      const timestamp = +Date.now()

      state.timestampClosed = timestamp
      localStorage.setItem('promotedBonusTimestampClosed', timestamp)
    },
  },
  getters: {
    getPromotedBonusPropsMap: (s) => {
      return s.promotedBonusList.reduce((acc = {}, promotedBonus) => {
        acc[promotedBonus.program.id] = promotedBonus.props
        return acc
      }, {})
    },
    getPromotedBonusListId: (s) => s.promotedBonusList.map((i) => Number(i.program?.id)),

    getPromotedBonusAvailable: (s, g) => {
      const programAvailable = g.getProgramsAvailable.find((i) => {
        return g.getPromotedBonusListId.includes(Number(i.program.id))
      })

      if (programAvailable) {
        return {
          ...programAvailable,
          props: g.getPromotedBonusPropsMap[Number(programAvailable.program.id)],
        }
      }

      return null
    },
    getPromotedBonusActiveStep: (s, g) => {
      const id = g.getActiveStep?.userProgram?.program?.id

      if (id && g.getPromotedBonusListId.includes(Number(id))) {
        return {
          ...g.getActiveStep,
          props: g.getPromotedBonusPropsMap[Number(id)],
        }
      } else {
        return null
      }
    },

    isShowAvailableBonus: (s, g) => {
      if (g.getPromotedBonusAvailable && !g.getActiveStep) {
        if (s.timestampClosed === null) {
          return true
        } else {
          return +Date.now() > +s.timestampClosed + MILLISECONDS_DAY
        }
      }

      return false
    },
    getPromotedBonusTitle: (s, g) => {
      const titleRaw = g.getPromotedBonusAvailable?.program?.title ?? ''
      return titleRaw.replace(/(.*)#(.+)#(.*)/gi, '$1<span>$2</span>$3')
    },
    getPromotedBonusId: (s, g) => g.getPromotedBonusAvailable?.id,

    getPromotedBonusContent: (s, g) => {
      if (g.getPromotedBonusActiveStep) {
        return g.getPromotedBonusActiveStep.props
      } else if (g.getPromotedBonusAvailable) {
        return g.getPromotedBonusAvailable.props
      }

      return null
    },
  },
}
